import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useLocation, useParams } from 'react-router-dom';
import { RouterDialog } from 'shared/components/dialogs/router';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
export const SupportChatMainDialog = memo(function SupportChatMainDialog() {
    const { pathname } = useLocation();
    const { ticket_id } = useParams();
    const getTitle = useCallback((pathname) => {
        if (pathname == '/support/list') {
            return 'Заявки в тех.поддержку';
        }
        if (pathname.search('/support/issue/') != -1) {
            return `Заявка №${ticket_id}`;
        }
        if (pathname == '/support/learning') {
            return 'Описание интерфейса';
        }
        if (pathname == '/support/beta') {
            return 'Бета-тестирование';
        }
        return 'Поддержка';
    }, [ticket_id]);
    return (_jsx(ErrorBoundary, { children: _jsx(RouterDialog, { title: getTitle(pathname), sx: {
                ...(isMediumUI() && {
                    '& .MuiDialog-paper': {
                        m: 1,
                        height: '100%',
                        width: '100%',
                        maxWidth: '800px',
                    },
                    '& .MuiDialog-paperScrollPaper': {
                        maxHeight: '80%',
                    },
                }),
            } }) }));
});
